module.exports = __webpack_public_path__ + "img/symfony.b05f9047.png";